import { CONFIGURATION_KEYS, ROLES, TASKS_OVERVIEW } from 'constants/enums'

export const tabs = [
  {
    id: 1,
    label: 'Award Leaders',
    intlKey: 'tabs.award_leaders',
    path: '/award-leaders',
    counters: [TASKS_OVERVIEW.AL_REGISTRATION.id]
  },
  {
    id: 2,
    label: 'Award Units',
    intlKey: 'tabs.award_units',
    path: '/award-units',
    counters: [TASKS_OVERVIEW.AU_REGISTRATION.id]
  },
  {
    id: 3,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: '/participants',
    counters: [TASKS_OVERVIEW.AWARD_REGISTRATION.id]
  },
  {
    id: 4,
    label: 'Unassigned Participants',
    intlKey: 'tabs.unassigned_participants',
    path: '/unassigned-participants',
    counters: [TASKS_OVERVIEW.UNASSIGNED_PARTICIPANTS.id]
  },
  {
    id: 5,
    label: 'Invited Participants',
    intlKey: 'tabs.invited_participants',
    path: '/invited-participants',
    counters: [TASKS_OVERVIEW.INVITED_PARTICIPANTS.id],
    roles: [ROLES.NAO_STAFF.u, ROLES.OA.u],
  },
  {
    // SHOW ONLY FOR AUSTRALIA
    id: 6,
    label: 'Assessors',
    intlKey: 'tabs.assessors',
    path: '/assessors',
    configs: [CONFIGURATION_KEYS.manageAssessors.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.ASSESSOR_REGISTRATION.id]
  },
  {
    // SHOW ONLY FOR AUSTRALIA
    id: 7,
    label: 'Assessors Activity',
    intlKey: 'tabs.assessors_activity',
    path: '/assessors-activity',
    configs: [CONFIGURATION_KEYS.manageAssessors.id],
    roles: [ROLES.ALL.u],
    counters: [TASKS_OVERVIEW.ASSESSOR_ACTIVITY_REGISTRATION.id]
  },
]
